export default __webpack_public_path__ + "static/media/mapper-action.f0b96311.svg";